import React, { Fragment, useState,useEffect } from "react";
import { Button,TextField } from "@material-ui/core";
import { AttachFile } from "@material-ui/icons";
import useStyles from "./styles";
import { pathOr, clone } from 'ramda';
import { useSelector } from 'react-redux';


const FileUpload = ({ field, onChange, errors = {}, value=[], small = false,variant = "outlined", readOnly,disabled  }) => {
  const classes = useStyles();
  const [error, setError] = useState(null);
  const [fileName, setFileName] = useState(pathOr('', [0,'name'], value)?pathOr('', [0,'name'], value):pathOr('', ['name'], value));

  const [TextValue, setTextValue] = useState(false)
  const config = useSelector((state) => state.config);
  const maxupload = pathOr(314572800, ['config', 'upload_maxsize'], config);

  useEffect(()=>{
    if(fileName===''){
      // setFileName(value.);
      console.log("ffffffffilename",fileName)
    }
    const data = getFieldLabel();
    if(data.props.children[0]=== fileName)
    {
      setTextValue(true);
    }
    else
    {
      setTextValue(false);
    }
    // ? (setTextValue(getFieldLabel().props.children[0]=== fileName)) : setTextValue("Upload")
  },[fileName])

  let iserror = errors[field.name] ? true : false;
  
   const getFieldLabel = () => {
     
    if (fileName!=='') {
   
      //  if(field.type==='image'){
      //  return <span className={classes.fileName}>{ pathOr(field.value, [0, 'name'], value)}  {field.required === 'true' ? '*' : ''}</span>;
      
      // }else {
      // setTextValue("File")
      return <span className={classes.fileName}>{fileName}  {field.required === 'true' ? '*' : ''}</span>;
      //value.name?value.name:value.file_name?value.file_name:value
      // }
    }else{
      return (
      <>
        <span>{`Upload ${field.label}`}  {field.required === 'true' ? "*" : ''}</span>
        <AttachFile />
      </>
    ); 
    } 

  };
 
  const validateAndChange = file => {
    setError(null);
    setFileName(file.name)
    // console.log("fffffffffffffffffile",file)
    if (field.type==="image") {
      if(file &&  ((file.size) <= maxupload)){
        onChange(file);
        return;
      } else {
        let err = "Choose document within "+ ((maxupload / 1024) / 1024 )+ "MB";
        setError(err);
        return;
      }
    }
console.log(((file.size / 1024)/1024)," <= "+maxupload);
console.log(((file.size))," <= "+maxupload);

    if(file &&  ((file.size) <= maxupload)){
      onChange(file);
    } else {
      //console.log("Choose document within 2mb",file.size)
      let err = "Choose document within "+ ((maxupload / 1024) / 1024 )+ "MB";
      setError(err);
    }
  }
  const removeFile = ()=>{
    setFileName('');
    onChange('');
    setError('');
  }

  return (
    <Fragment>
      <Button
        className={iserror ? classes.errorFile : ""}
        variant="outlined"
        component="label"
        id={field.name}
        name={field.name}
        size={small ? "small" : "large"}
        color="primary"
        fullWidth
        disabled={fileName!==''?true:false}
      >
        {getFieldLabel()}
        <TextField
          type="file"
          accept={field.type!=='image'?"application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, image/*":"image/*"}
          error={iserror}
          required={!TextValue ? true : false}
          name={field.name}
          variant={variant}
          // helperText={errors[field.name] ? errors[field.name] : null}
          style={{ display: "none" }}
          
          onChange={(e) => validateAndChange(e.target.files[0])}
      />
      </Button>
      {fileName!==''? (
    
    <span className={classes.removeBtn} onClick={() => removeFile()}>
          remove file
        </span>
      
      ):null}
      {error && <span className={classes.error}>
          {error}
         
        </span>}
        <span className={classes.error}>
        {errors[field.name] ? errors[field.name]:null}
        </span>
    </Fragment>
  );
};

export default FileUpload;
